<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate class="flex w-full">
    @if(!isValidCode()){
    <div class="flex w-full flex-col">
        <div class="flex w-full relative">
            <input class="input__base w-full" type="text" id="referralCode" formControlName="referralCode"
                [ngClass]="{
                            error:showErrors()}" />
            <button class="input__button">Aplicar</button>
        </div>

        @if (showErrors()) {
        <div class="error">
            @if (form.get('referralCode')?.errors?.['required']) {
            <div>Este campo es requerido</div>
            }
            @if (form.get('referralCode')?.errors?.['validMeridionalCode']) {
            <div>Código de referido inválido.</div>
            }
        </div>
        }
    </div>
    }
    @if(isValidCode()){
    <div class="flex justify-between w-full">
        <div>
            Código de referido: <strong>{{form.get('referralCode')?.value}}</strong>
        </div> 

        <div>
            <button class="text-primary-500 font-bold">Eliminar</button>
        </div>
    </div>
    }
</form>